import Mark, { Range } from "mark.js";

function getAlphanumericRanges(text: string, container: HTMLElement): Range[] {
  const containerText = container.textContent || "";
  const ranges: Range[] = [];

  try {
    let startIndex = -1;
    let textIndex = 0;

    for (let i = 0; i < containerText.length; i++) {
      const char = containerText[i];

      if (/[a-zA-Z0-9]/.test(char)) {
        const alphanumericChar = text[textIndex];
        if (char === alphanumericChar) {
          if (startIndex === -1) {
            startIndex = i;
          }
          textIndex++;

          if (textIndex === text.replace(/[^a-zA-Z0-9]/g, "").length) {
            ranges.push({ start: startIndex, length: i - startIndex + 1 });
            startIndex = -1;
            textIndex = 0;
          }
        } else {
          startIndex = -1;
          textIndex = 0;
        }
      }
    }
  } catch (error) {
    console.error("Error in getAlphanumericRanges: ", error);
  }

  return ranges;
}

export const highlightPlainText = async ({
  text,
  highlightClassName = "highlighted-text",
  container,
  id,
  data,
  shouldScroll,
  backgroundColor,
}: {
  id?: string;
  text: string;
  highlightClassName?: string;
  container: string | HTMLElement;
  data?: Record<string, unknown>;
  shouldScroll?: boolean;
  backgroundColor?: string;
}) => {
  const instance = new Mark(container);

  const containerElement = (
    typeof container === "string" ? document.querySelector(container) : container
  ) as HTMLElement;
  const alphanumericText = text.replace(/[^a-zA-Z0-9]/g, "");
  const ranges = getAlphanumericRanges(alphanumericText, containerElement);

  if (ranges.length === 0) {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    instance.markRanges(ranges, {
      className: highlightClassName,

      noMatch: function () {
        console.debug("In markRegExp, No match found for: ", JSON.stringify(text));
      },
      filter(textNode: Text) {
        // if one of the ascendants of textNode has the id side-panel, don't highlight it
        let currentNode = textNode.parentNode as HTMLElement;
        while (currentNode) {
          if (currentNode.id === "side-panel") return false;
          currentNode = currentNode.parentNode as HTMLElement;
        }

        return true;
      },
      each(element: HTMLElement) {
        if (id) element.id = id;
        if (data && data["dataType"] === "citation") {
          element.dataset.popupId = data.popupId as string;
        }
        if (shouldScroll) element.scrollIntoView({ behavior: "smooth" });

        if (backgroundColor) {
          element.style.backgroundColor = backgroundColor;
        }
      },
      done() {
        resolve(true);
      },
    });
  });
};
